body{color:#abc}


/** WEBPACK FOOTER **
 ** ./parsing/bom/bomfile.css
 **/